<template>
    <div>
        <!--调拨报表-->
        <header class="form-title">
            <Row>
                <Col span="24">
                    <Form  inline  :label-width="80" >
                        <FormItem  label="选择时间" style="margin-right: 200px">
                            <DatePicker
                                    split-panels
                                    type="daterange"
                                    :options="options"
                                    placeholder="选择日期"
                                    @on-change="modifyTime"
                                    :value="valuedate"
                            >
                            </DatePicker>
                        </FormItem>
                        <FormItem  label="调拨单数:" style="margin-right: 30px">
                            <strong class="result">{{dataTotl.totalNum}}</strong>
                        </FormItem>
                        <FormItem  label="调拨总数:" style="margin-right: 30px">
                            <strong class="result">{{dataTotl.totalGoodsNum}}</strong>
                        </FormItem>
                        <!-- 导出 -->

                        <FormItem>
                            <Button type="primary" size="small" @click="exportExcel">导出</Button>
                        </FormItem>
                    </Form>
                </Col>
            </Row>
        </header>
        <Table stripe :columns="columns" :data="data" :loading="loadingTable">
            <template slot-scope="{ row, index }" slot="first">
                <span v-if="row.type==0" style="color: #ff6666">已调入</span>
                <span v-if="row.type==1" style="color: #46bab2">已调出</span>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <Button type="primary" size="small" @click="$router.push({path:'/diaoboDetail',query:{id:row.id}})">详情</Button>
            </template>
        </Table>
        <div class="pageTotal"  >
            <Page :total="page.total"
                  show-total
                  :page-size="page.rows"
                  @on-change="onGongPageTotal" />
        </div>
    </div>
</template>
<script>
import { exportExcel } from '@/common/exportExcel';
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                columns: [
                    {title: '类型', key: 'type',align:'center',slot: 'first',},
                    {title: '调拨店铺', key: 'comename',align:'center' },
                    {title: '订单号', key: 'code' ,align:'center' },
                    {title: '调拨人', key: 'adminName',align:'center'  },
                    {title: '调拨时间', key: 'time' ,align:'center' },
                    {title: '操作', key: 'edit' ,align:'center',slot: 'action',},
                ],
                data: [],
                dataTotl:{},
                page:{
                    total:0,
                    page:1,
                    rows:10
                },
                loadingTable:true
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.valuedate[0] = this.fun_date(-7)
            this.valuedate[1] = this.nowTime
            this.selectInventory(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
        },

        methods: {
            exportExcel() {
                const params = {
                    cid: this.cid,
                    sid: this.sid,
                    time: this.valuedate[0],
                    endtime:this.valuedate[1],         
                };
                exportExcel(this.$Api.exportInventory, params, this.$Message, new Date().toLocaleString() + '调拨报表');
            },
            //获取采购单
            selectInventory(startTime,endTime,page,rows){
                this.$Api.selectInventory({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows: rows,
                    time: startTime,
                    endtime:endTime,

                }).then(res => {
                    if(res.code==200){
                        this.data=[]
                        this.page.total = res.count
                        res.data.forEach((item,index)=>{
                             var PurchaseList={}
                             PurchaseList.id = item.id,
                             PurchaseList.type = item.type
                            PurchaseList.comename=item.comename,
                            PurchaseList.code= item.code,
                            PurchaseList.adminName= item.adminName,
                            PurchaseList.time=item.time
                           this.data.push(PurchaseList)

                        })
                        this.loadingTable=false
                        this.selectInventoryData(startTime,endTime)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            selectInventoryData(startTime,endTime){
                this.$Api.selectInventoryData({
                    cid: this.cid,
                    sid: this.sid,
                    time: startTime,
                    endtime:endTime,

                }).then(res => {
                    if(res.code==200){
                        this.dataTotl = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            modifyTime(data){
                this.valuedate[0] = data[0]
                this.valuedate[1] = data[1]
                this.selectInventory(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
            },
            onGongPageTotal(num){
               
                this.selectInventory(this.valuedate[0],this.valuedate[1],num,this.page.rows)
            }
        }
    };
</script>

<style lang="scss" scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        color: #ff5e5e;
    }
    .tableFirst{
        color: #ff5e5e;
    }
</style>